export class ModelFilter {

  modelCode: string;
  sortAscending = true;
  order: string;
  brand: number;
  page = 0;
  pageSize = 20;
}
